<template>
    <div class="workTime">
        <servicesList></servicesList>
        <div class="time_content" ref="padT" :style="{'padding-top': height}">
            <div class="time_title">
                <p>{{$t('name')}} <br>{{$t('service.work_time')}}</p>
            </div>
            <div class="information">
                <p>{{$t('time_notice')+ $t('consult_tel')}}：0757-27331088</p>
            </div>
            <timeList v-for="(n,i) in timeList" :work_time='n' :timeIndex="i"></timeList>
        </div>


    </div>
</template>

<script>
    import timeList from '../../components/services/timeList';
    import servicesList from '../../components/services/servicesList';

    export default {
        name: "workTime",
        components: {
            timeList,
            servicesList,
        },
        data() {
            return {
                timeList: '',
                height: "",
                child1: '',
                child2: '',
                // lang:window.i18n.locale
            }
        },
        created: function () {
            this.getTime();
            this.$store.commit("set_current", 5);
            this.$store.commit("set_current_index", 2);
            this.$store.commit("set_title", 'nav.service');

        },
        methods: {
            getTime: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/serve/getHours",
                    dataType: "json",
                    data:{
                        lang: window.$lang
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            this.timeList = res.data.result;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.child1 = this.$refs.padT.childNodes[0].clientHeight;
                this.child2 = this.$refs.padT.childNodes[1].clientHeight;
                this.height = this.child2 + this.child1 + 10 + "px";
            });
        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            }
        },
        updated() {
            this.height = this.$refs.padT.childNodes[1].clientHeight + this.$refs.padT.childNodes[0].clientHeight + 10 + "px";
        }

    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common.less";

    .workTime {
        width: @width;
        .time_content {
            padding: 145px 10px 10px 10px;
            .box-sizing;
            width: @width;
            background: #ffd5a3;
            position: relative;
            /* @media(max-width: 320px){
                 padding: 147px 10px 10px 10px;
             }*/

            .time_title {
                position: absolute;
                top: 10px;
                left: 10px;
                width: calc(@width - 20px);
                height: 84px;
                background: url(../../assets/images/service/work_time.png) no-repeat;
                background-size: 100% auto;
                text-align: center;
                z-index: 99;
                @media (max-width: 320px) {
                    height: 78px;
                }
                p {
                    padding-top: 10px;
                    color: @font-primary;
                    font-size: @font - .2;
                    text-shadow: 2px 2px 8px #00000061;
                    line-height: @font;
                    @media (max-width: 320px) {
                        font-size: @font - .3;
                    }
                }
            }
            .information {
                position: absolute;
                top: 80px;
                left: 10px;
                width: calc(@width - 20px);
                /*height: 54px;*/
                .border-radius(10px);
                .box-sizing;
                background: @font-primary;
                padding: 15px 10px 10px;
                @media (max-width: 320px) {
                    top: 69px;
                    height: 69px;
                }
                @media (max-width: 360px) {
                    top: 77px;
                }
                p {
                    font-size: @font - .2;
                    line-height: 16px;
                }

            }

        }
    }

    @media (min-width: 768px) {
        .workTime {
            .time_content {
                padding: 263px 10px 10px 10px;
                .time_title {
                    height: 173px;
                    p {
                        padding-top: 30px;
                        font-size: @font + .4;
                        line-height: @font + .7;
                    }
                }
                .information {
                    top: 156px;
                    height: 74px;
                    padding: 32px 20px 10px;
                    p {
                        font-size: @font;
                    }

                }

            }
        }
    }

</style>
